export type PriceArchitectureConfigResponse = {
  enabled: boolean;
  applyPsychologicalPricing: boolean;
  updateBy: string | null;
  updatedAt: string | null;
};

export type PriceArchitectureFormValues = Pick<PriceArchitectureConfigResponse, 'enabled' | 'applyPsychologicalPricing'>;

export type SavePriceArchitectureConfigPayload = PriceArchitectureFormValues;

export const DEFAULT_PRICE_ARCHITECTURE_VALUES: PriceArchitectureFormValues = {
  enabled: false,
  applyPsychologicalPricing: true,
};

export const PRICE_ARCHITECTURE_QUERY_KEY = ['ipa/setup-form/architecture-config'] as const;

export type UsePriceArchitectureConfigReturn = {
  values: PriceArchitectureFormValues;
  isLoading: boolean;
  isSaving: boolean;
  error: unknown;
  setEnabled: (enabled: boolean) => void;
  setApplyPsychologicalPricing: (applyPsychologicalPricing: boolean) => void;
  reset: () => void;
  save: () => Promise<void>;
};
